import { Input } from "../ui/input";
import { VenueTicks } from "./VenueTicks";

const TIER_DAYS = { "mini-break": 5, premium: 9, ultra: 14, elite: 19 };
export const REVIEW_OPTS = {
  collections: [["researched", "Researched Kit"], ["founders", "Founder's Collection"], ["standalone", "Standalone Kit"], ["guide", "One-off Guide"]],
  editions: [["luxury", "Luxury"], ["solo", "Solo"], ["wine", "Wine"], ["escape", "Escape"], ["adventure", "Adventure"]],
  tiers: [["mini-break", "Mini-Break"], ["premium", "Premium"], ["ultra", "Ultra"], ["elite", "Elite"]],
  topics: [["accommodation", "Accommodation"], ["destination", "Destination"], ["dining", "Dining"], ["experiences", "Experiences"]],
  tierDays: TIER_DAYS,
};

export const reviewFrom = (g, iid, collection) => ({
  ...g, iid, collection, destination: collection === "guide" ? (g.title || g.destination) : g.destination,
  topic: g.topic || "accommodation", subjects: g.subjects || [], unvisited: [],
});

export const confirmBody = (r, queue = false) => {
  const sub = (r.subjects || []).map((x) => x.trim()).filter(Boolean);
  if (r.collection === "guide" && sub.length !== 4) throw new Error("A one-off guide needs exactly 4 subjects");
  return { collection: r.collection, edition: r.edition, destination: r.destination, season: r.season, tier: r.tier, days: Number(r.days) || 0,
    subjects: r.collection === "guide" ? sub : [], topic: r.collection === "standalone" ? (r.topic || "accommodation") : "", unvisited: r.unvisited || [], queue };
};

const Field = ({ label, children }) => (
  <label className="block">
    <div className="eyebrow mb-1.5">{label}</div>
    {children}
  </label>
);

const Sel = ({ id, value, onChange, opts }) => (
  <select data-testid={id} value={value} onChange={(e) => onChange(e.target.value)} className="h-11 w-full rounded-md border border-stone-300 bg-white px-3 text-sm">
    {opts.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
  </select>
);

export const ImportReview = ({ r, setR, opts = REVIEW_OPTS, filename }) => {
  const set = (k, v) => setR((s) => ({ ...s, [k]: v }));
  const full = ["researched", "founders"].includes(r.collection);
  return (
    <div data-testid="import-review-card" className="mb-10 rounded-xl border border-[#C9A847]/60 bg-[#FBF8F0] p-6">
      <div className="font-display text-2xl text-[#2B2A26]">Check what I found</div>
      <p className="text-xs text-stone-500 mt-1 mb-5">Read from <b>{filename}</b>{r.pages ? ` · ${r.pages} pages` : ""}. Correct anything that's wrong, then start the import.</p>
      <div className="grid md:grid-cols-2 gap-4">
        <Field label="Change collection"><Sel id="review-collection" value={r.collection} onChange={(v) => set("collection", v)} opts={opts.collections} /></Field>
        <Field label="Edition"><Sel id="review-edition" value={r.edition} onChange={(v) => set("edition", v)} opts={opts.editions} /></Field>
        <Field label={r.collection === "guide" ? "Guide title" : "Destination"}>
          <Input data-testid="review-destination" value={r.destination} onChange={(e) => set("destination", e.target.value)} className="h-11 bg-white" />
        </Field>
        {r.collection === "standalone" && <Field label="Topic"><Sel id="review-topic" value={r.topic || "accommodation"} onChange={(v) => set("topic", v)} opts={opts.topics} /></Field>}
        {full && <>
          <Field label="Season"><Input data-testid="review-season" value={r.season} onChange={(e) => set("season", e.target.value)} className="h-11 bg-white" /></Field>
          <Field label="Tier"><Sel id="review-tier" value={r.tier} onChange={(v) => setR((s) => ({ ...s, tier: v, days: opts.tierDays[v] || s.days }))} opts={opts.tiers} /></Field>
          <Field label="Number of days"><Input data-testid="review-days" type="number" min={2} max={30} value={r.days} onChange={(e) => set("days", e.target.value)} className="h-11 bg-white" /></Field>
        </>}
      </div>
      {r.collection === "guide" && (
        <div className="mt-4">
          <div className="eyebrow mb-1.5">The four subjects</div>
          <div className="grid md:grid-cols-2 gap-3">
            {[0, 1, 2, 3].map((i) => (
              <Input key={i} data-testid={`review-subject-${i}`} value={(r.subjects || [])[i] || ""} placeholder={`Subject ${i + 1}`}
                onChange={(e) => setR((s) => { const sub = [0, 1, 2, 3].map((j) => (s.subjects || [])[j] || ""); sub[i] = e.target.value; return { ...s, subjects: sub }; })} className="h-11 bg-white" />
            ))}
          </div>
        </div>
      )}
      {r.collection === "founders" && <VenueTicks r={r} setR={setR} />}
    </div>
  );
};
